<template>
  <div id="card-user-basic-info-view" v-if="user">
    <vx-card title="基本情報" class="mb-base">
      <div class="vx-row">
        <div class="vx-col" id="avatar-col">
          <div class="img-container mb-4">
            <figure>
              <img
                :src="photoUrl"
                class="rounded w-full"
                style="height: 112px"
              />
              <figcaption v-show="!photoUrl">{{ photoText }}</figcaption>
            </figure>
          </div>
        </div>
        <div class="vx-col flex-1" id="account-info-col-1">
          <table>
            <tr>
              <td class="font-semibold">名前</td>
              <td>{{ user.name || "---" }}</td>
            </tr>
            <tr>
              <td class="font-semibold">名前（ローマ字）</td>
              <td>{{ user.name_en || "---" }}</td>
            </tr>
            <tr>
              <td class="font-semibold">電話番号</td>
              <td>{{ user.phone_number || "---" }}</td>
            </tr>
            <tr>
              <td class="font-semibold">Eメール</td>
              <td>{{ user.email_address || "---" }}</td>
            </tr>
          </table>
        </div>

        <div class="vx-col flex-1" id="account-info-col-2">
          <table>
            <tr>
              <td class="font-semibold">在籍状況</td>
              <td>
                <vs-chip :color="chipColor" class="border-5"> {{ retirementStatus }}</vs-chip>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">退職日</td>
              <td>{{ retirementDate }}</td>
            </tr>
            <tr>
              <td class="font-semibold">社員番号</td>
              <td>{{ user.origin_number || "---" }}</td>
            </tr>
          </table>
        </div>

        <div class="vx-col w-full flex" id="account-manage-buttons">
          <vs-button
            icon-pack="feather"
            icon="icon-edit"
            class="mr-4"
            @click="popupActive = true"
            >編集</vs-button
          >
          <vs-button
            :disabled="isRetirement"
            icon-pack="feather"
            icon="icon-user-minus"
            class="mr-4"
            @click="showRetirementProcessingDialog"
            color="danger"
            >退職処理</vs-button
          >
          <vs-button
            icon-pack="feather"
            icon="icon-trash"
            class="mr-4"
            @click="showDialogUserDelete"
            type="border"
            color="danger"
            >削除</vs-button
          >
        </div>
      </div>
    </vx-card>
    <!-- ダイアログ -->
    <dialog-retirement-processing
      ref="dialogRetirementProcessing"
      @completeRetirement="completeRetirement"
    ></dialog-retirement-processing>
    <dialog-user-delete
      ref="dialogUserDelete"
      @completeDeleteUser="completeDeleteUser"
    ></dialog-user-delete>

    <vs-popup 
      class="popup-user-edit"
      :title="'社員情報編集'"
      :active.sync="popupActive">
      <div>
        <user-edit 
          class="mt-4"
          ref="userEditTabAccount"
          @closePopup="popupActive = false"
        />
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import { createNamespacedHelpers } from "vuex";
import DialogRetirementProcessing from "@/components/dialogs/DialogRetirementProcessing";
import DialogUserDelete from "@/components/dialogs/DialogUserDelete";
const { mapActions, mapState } = createNamespacedHelpers("enterpriseUserView");
import UserEdit from "../../user-edit/UserEdit.vue";

export default {
  components: {
    DialogRetirementProcessing,
    DialogUserDelete,
    UserEdit,
  },
  data() {
    return {
      photoUrl: null,
      photoText: "",
      popupActive: false,
    };
  },
  watch: {
    user() {
      this.createPhotoUrl();
    },
    popupActive() {
      if ( this.popupActive === false ) {
        // ユーザ編集ダイアログから戻ったら、データ取り直し
        this.fetchUser(this.user.id);
      }
    },
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    retirementDate() {
      return this.user.retirement_date === null
        ? "---"
        : this.user.retirement_date;
    },
    retirementStatus() {
      return this.user.retirement_date === null ? "在籍中" : "退職済";
    },
    isRetirement() {
      return this.user.retirement_date === null ? false : true;
    },
    chipColor() {
      return this.user.retirement_date === null ? "success" : "danger";
    }
  },
  methods: {
    ...mapActions(["fetchUser"]),
    showDialogUserDelete() {
      this.$refs.dialogUserDelete.show(this.user);
    },
    showRetirementProcessingDialog() {
      this.$refs.dialogRetirementProcessing.show(this.user);
    },
    completeRetirement() {
      this.fetchUser(this.user.id);
    },
    completeDeleteUser() {
      this.$router.push({
        name: "enterprise-management-user-list"
      });
    },
    createPhotoUrl() {
      if (this.user.pictures.length !== 0) {
        storage
          .child(this.user.pictures[0].thumbnail_path)
          .getDownloadURL()
          .then(response => {
            this.photoUrl = response;
          });
      } else {
        this.photoText = "No image";
      }
    }
  }
};
</script>

<style lang="scss">
.border-5 {
  border-radius: 5px;
}
#card-user-basic-info-view {
  #avatar-col {
    width: 10rem;
  }

  figure {
    position: relative;
  }

  figure img {
    vertical-align: top;
    background: #c0c0c0;
    object-fit: cover;
  }

  figure figcaption {
    font-size: 12px;
    color: #ffffff;
    position: absolute;
    top: 0;
    display: flex;
    width: 100%;
    height: 100%;
    margin: 0px;
    align-items: center;
    justify-content: center;
  }

  .popup-user-edit .vs-popup {
    width: calc(100vw - 600px);
    z-index: 10;
  }
}
</style>
